import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { DropdownItem } from '../../../event/models/dropdown-item';
import { PropertyLookupStore } from './property-lookup.store';

@Injectable()
export class PayorTypeResolver implements Resolve<any> {

    constructor(private propertyLookupStore: PropertyLookupStore,
                private authenticationStore: AuthenticationStore) { }

    resolve(): Observable<DropdownItem[]> {
      if (this.authenticationStore.hasPermission('MultiVendor')) {
        return this.propertyLookupStore.loadPayorTypes();
      }

    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/property-lookup/payor-type.resolver.ts